import { FlexLayout } from '@Styled/utilities';
import styled from 'styled-components';

export const ChipFlexLayout = styled(FlexLayout)`
	max-width: 16rem;
`;
